<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="子账户管理" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
		<div class="pb-30">
			<div class="item mt-5" v-for="item in sellerList" v-bind:key="item.seller_id" >
				<div class="div container">
					<div class="div account-info">
						<div class="lastlogin" v-if="item.last_logintime">
							<div>上次登录</div>
							<text>{{item.last_logintime}}</text>
						</div>
						<div class='seller_name'>
							<label class="subtitle">
								{{ item.seller_name }}
							</label>
						</div>
						<div class="div button-wrapper">
							<div class="div edit-wrapper" @click="onEdit(item.seller_id)">
								<div class="div common-btn btn-2">编辑</div>
							</div>
							<div class="div edit-wrapper delete-wrapper" @click="onDelete(item.seller_id)">
								<div class="div common-btn btn-1">删除</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
        <empty-record v-if="sellerList && !sellerList.length"></empty-record>
		<div class='common-add-btn-wrapper'><div class="div common-btn common-add-btn"  @click="goAdd">新增</div></div>
    </div>
</template>

<script>
import { Indicator, Toast,MessageBox } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import { getSellerAccountList,delSellerAccount } from '../../../api/sellerAccount'
import flexLine from '../../flexLine'
export default {
  name: 'AccountList',
  components:{
    flexLine,
    EmptyRecord
  },
  data () {
    return {
      sellerList: false // 用户列表
    }
  },
  created: function () {
    this.getAccountList()
  },
  methods: {
    getAccountList () {
      Indicator.open()
      getSellerAccountList().then(res => {
        Indicator.close()
        this.sellerList = res.result.seller_list
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    },
	onDelete (id) {
		MessageBox.confirm('确定要取消该账号吗？').then(action => {
			delSellerAccount(id).then(res => {
				if (res) {
				  this.getAccountList()
				}
			}).catch(function (error) {
			  Toast(error.message)
			})
		})
	},
    onEdit (sellerId) {
      this.$router.push({ name: 'SellerAccountForm', query: { seller_id: sellerId } })
    },
    goAdd () {
      this.$router.push({ name: 'SellerAccountForm', query: { action: 'add' } })
    }
  }

}
</script>

<style scoped lang="scss">
.common-header{
        .btn{background: #000;color: #fff;box-shadow: 0px 2px 4px #d2d2d2;}
    }
.item{background-color: #fff;}
.account-info {padding: .5rem 1rem 1.5rem;box-sizing: border-box;}
.account-info .lastlogin view{font-size: .7rem;color: #333;}
.account-info .lastlogin text{font-size: .7rem;color: #999;}
.account-info .seller_name {text-align: center;padding: 2rem 0 1rem;}
.account-info .seller_name .subtitle {font-size:1rem;color: #333;font-weight: bold;}
.account-info .button-wrapper {flex: 1;display: flex;flex-direction: row;justify-content: center;align-items: center;}
.account-info .button-wrapper .edit-wrapper{color: #fff;border-radius: 1.5rem;padding: .1rem .3rem;margin: 0 .2rem;background: $primaryColor;}
.account-info .button-wrapper .edit-wrapper .common-btn{color: #fff;padding:.5rem 3rem ;white-space: nowrap;}
.account-info .button-wrapper .delete-wrapper{background: #FB2630;}
</style>
